const LookupTypeEnum = {
  Class: {
    id: 1,
    name: "Class",
  },
  Category: {
    id: 2,
    name: "Category",
  },
  Type: {
    id: 3,
    name: "Type",
  },
  SalesTax: {
    id: 4,
    name: "SalesTax",
  },
  Status: {
    id: 5,
    name: "Status",
  },
  Roles: {
    id: 6,
    name: "Roles",
  },
  WarrantyUnit: {
    id: 7,
    name: "WarrantyUnit",
  },
  AddressCountry: {
    id: 8,
    name: "AddressCountry",
  },
  AddressProvince: {
    id: 9,
    name: "AddressProvince",
  },
  CompanyService: {
    id: 10,
    name: "CompanyService",
  },
  QuoteType: {
    id: 11,
    name: "QuoteType",
  },
  ServiceInterval: {
    id: 12,
    name: "ServiceInterval",
  },
  EmergencyType: {
    id: 13,
    name: "EmergencyType",
  },
};

export default LookupTypeEnum;
